@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.header {
  color: var(--cxy-color-text-default-body);
  padding: var(--cxy-spacing-xxsm) 0;
}

.dialogWrapper {
  width: 100%;
  height: calc(100vh - 68px);
  grid-template-areas: 'content' 'footer';
  @include cxy.grid;
  grid-template-rows: auto 150px;
}

.content {
  grid-area: content;
}

.footer {
  grid-area: footer;
}

.applyButton {
  height: 50px;
  text-transform: uppercase;
}

.scroll {
  overflow-y: auto;
}

.filtersButton {
  display: flex;
  align-items: center;
  gap: var(--cxy-spacing-xxxsm);
}
.filtersButton > .filtersCount {
  margin-inline-end: calc(-1 * var(--cxy-spacing-xxxsm));
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  --window-height: calc(var(--parent-window-height, 100%) - var(--parent-header-height));
  --dialog-wrapper-padding-y: var(--cxy-spacing-xsm);
  --dialog-close-button-height: 84px;
  --dialog-footer-height: 54px;
  --dialog-wrapper-height: calc(
    var(--window-height) - var(--dialog-close-button-height) - var(--dialog-wrapper-padding-y)
  );
  --dialog-content-height: calc(var(--dialog-wrapper-height) - var(--dialog-footer-height));

  .scroll {
    top: var(--parent-window-top-offset, 0px);
    height: var(--window-height) !important;
  }
  .dialogWrapper {
    grid-template-rows: var(--dialog-content-height) var(--dialog-footer-height);
    height: var(--dialog-wrapper-height);
  }
  .content {
    overflow-y: auto;
  }
  .filtersButton {
    border-radius: 60px;
    background-color: var(--cxy-color-container-strong);
    color: var(--cxy-color-text-default-placeholder);
  }
  .applyButton {
    background-color: var(--cxy-color-surface-secondary-default-subtle);
    color: var(--cxy-color-text-default-placeholder);

    &:disabled {
      background-color: var(--cxy-color-container-track);
      color: var(--cxy-color-content-muted);
    }
  }
  .filtersButton > .filtersCount {
    margin-inline-end: calc(-1 * var(--cxy-spacing-xxxsm));
    color: var(--cxy-color-text-default-placeholder);
  }
}
